"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var types = __importStar(require("@babel/types"));
var utils_1 = require("../utils");
function parseSlot(_a) {
    var value = _a.value, dg = _a.dg, childrens = _a.childrens, attrs = _a.attrs;
    if (types.isCallExpression(value.node) && /\_u/.test(value.get("callee").toString())) {
        var _u_args = value.get("arguments");
        if (types.isArrayExpression(_u_args[0].node)) {
            var elements = _u_args[0].get("elements");
            elements.forEach(function (element) {
                var key = null;
                var fn = null;
                // @ts-ignore
                element.get("properties").forEach(function (propertie) {
                    if (types.isObjectProperty(propertie.node)) {
                        // key = 
                        if (propertie.node.key.name == "key") {
                            key = propertie.node.value;
                        }
                        if (propertie.node.key.name == "fn") {
                            fn = propertie.get("value");
                        }
                    }
                });
                if (key && fn) {
                    var slotAttr = [];
                    var slotChildrens = [];
                    // 判断是否是静态名字
                    if (types.isStringLiteral(key)) {
                        slotAttr.push(types.jsxAttribute(types.jsxIdentifier("slot"), key));
                    }
                    else {
                        slotAttr.push(types.jsxAttribute(types.jsxIdentifier("slot"), types.jsxExpressionContainer(key)));
                    }
                    if (types.isFunctionExpression(fn.node)) {
                        // @ts-ignore
                        if (fn.get("params").length > 0) {
                            // @ts-ignore
                            fn.scope.rename(fn.get("params")[0].toString(), "slotProps");
                            // @ts-ignore
                            var slotScopeAttr = types.jsxAttribute(types.jsxIdentifier("slot-scope"), types.stringLiteral(fn.get("params")[0].toString()));
                            // @ts-ignore
                            for (var key_1 in fn.scope.bindings) {
                                var binding = fn.scope.bindings[key_1];
                                if (binding.kind == "var") {
                                    var init = binding.path.get("init").toString();
                                    fn.scope.rename(key_1, init);
                                }
                            }
                            slotAttr.push(slotScopeAttr);
                        }
                        // @ts-ignore
                        var returnNode = fn.get("body.body")[fn.get("body.body").length - 1];
                        if (types.isSequenceExpression(returnNode.get("argument").node)) {
                            var returnNodePlus = returnNode.get("argument.expressions")[returnNode.get("argument.expressions").length - 1];
                            // let sequenceExpression = returnNode.get("argument.expressions")
                            // if(types.is)
                            returnNodePlus.get("elements").forEach(function (e) {
                                slotChildrens.push(dg(e));
                            });
                        }
                        if (types.isArrayExpression(returnNode.get("argument").node)) {
                            returnNode.get("argument.elements").forEach(function (e) {
                                slotChildrens.push(dg(e));
                            });
                        }
                    }
                    // 独占 slotScope 处理
                    if (elements.length == 1) {
                        attrs.push.apply(attrs, slotAttr);
                        childrens.push.apply(childrens, slotChildrens.flat());
                    }
                    else {
                        childrens.push(utils_1.renderJSX({
                            tagName: types.jsxIdentifier("template"),
                            attrs: slotAttr,
                            childrens: slotChildrens.flat()
                        }));
                    }
                }
            });
        }
    }
}
exports.parseSlot = parseSlot;
//# sourceMappingURL=slot.js.map